<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> account_balance </v-icon>
      <span :class="ui.textHeadline"> New Company </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Review new company requests, verify the new Business application and Company Director.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <v-spacer/>
        <GetAccessListPage :data="{tag: 'G1', tagd: 'Z5', tags: 'C1'}"/>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import GetAccessListPage from "@/support/access/components/GetAccessListPage";

export default {
  mixins: [apptheme],
  components: {
    GetAccessListPage
  }
};
</script>
